import { render } from "./BlogSinglePost.vue?vue&type=template&id=08adffcd"
import script from "./BlogSinglePost.vue?vue&type=script&lang=js"
export * from "./BlogSinglePost.vue?vue&type=script&lang=js"

import "./BlogSinglePost.vue?vue&type=style&index=0&id=08adffcd&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__